import { browserHistory } from 'react-router';
export default browserHistory;




// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/router/history.js